// src/components/foam/FoamRegistered.js
//
// Screen 3 · Registered (success — the "My WAKA." moment)
// Doc: 2026-06 design-system handoff "Screen 3" — carbon theme.
// Updated 2026-06-04: WAKA Design System pass. The big moment is now
// Saira Condensed 800 (NOT Fasten — Fasten is logo-only per the locked
// design system). 104px, line-height 0.88, "WAKA." in orange on its own line.

import React from 'react';
import { FScreen, FHeader, FLabel, FHeadline, FBtn } from './FoamPrimitives';

const NEXT_STEPS = [
  { n: '01', title: 'Add another board', sub: 'Bag, paddle, rolling case…', action: '/' },
  { n: '02', title: 'Care guide',         sub: 'Folding, drying, storing',   action: 'https://waka.surf/pages/care' },
  { n: '03', title: 'See your boards',    sub: null,                          action: '/boards' },
];

const FoamRegistered = ({ product, registrationDate, onDone }) => {
  const dateLabel = registrationDate
    ? new Date(registrationDate).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })
    : new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

  const header = (
    <FHeader
      dark
      right={
        <FLabel color="var(--foam-orange)" className="!text-foam-orange">
          ✓ Verified
        </FLabel>
      }
    />
  );

  const footer = (
    <FBtn primary onClick={onDone}>
      Done →
    </FBtn>
  );

  return (
    <FScreen dark header={header} footer={footer}>
      <div className="mt-[8px]">
        <FLabel color="var(--foam-mute)">✓ Registered · {dateLabel}</FLabel>

        <div className="mt-[18px]">
          <FHeadline size={104} lineHeight={0.88} color="var(--foam-paper)">
            My
            <FHeadline.Accent block>WAKA.</FHeadline.Accent>
          </FHeadline>
        </div>

        <p className="text-[17px] leading-[1.45] mt-[24px]" style={{ color: '#C4C1B5' }}>
          {product?.name || 'Your board'}{product?.serial ? `, serial ${product.serial},` : ''}{' '}
          is on your account. Two-year warranty active. Findability is on — if
          it ever wanders off, a finder can reach you.
        </p>
      </div>

      <div className="flex-1" style={{ minHeight: 12 }} />

      <div
        className="flex flex-col"
        style={{ border: '1.5px solid var(--foam-paper)' }}
      >
        {NEXT_STEPS.map((step, i) => (
          <a
            key={step.n}
            href={step.action}
            className="flex items-center gap-[18px] p-[16px]"
            style={{
              borderBottom: i < NEXT_STEPS.length - 1 ? '1px solid var(--foam-carbon-2)' : 'none',
              color: 'var(--foam-paper)',
              textDecoration: 'none',
            }}
          >
            <div
              className="font-mono text-[13px] tracking-[0.08em]"
              style={{ color: 'var(--foam-mute)', minWidth: 24 }}
            >
              {step.n}
            </div>
            <div className="flex-1">
              <div className="text-[17px] font-semibold">{step.title}</div>
              {step.sub && (
                <div className="text-[12px] mt-[3px]" style={{ color: 'var(--foam-mute)' }}>
                  {step.sub}
                </div>
              )}
            </div>
            <div className="text-foam-paper text-[18px]">→</div>
          </a>
        ))}
      </div>
    </FScreen>
  );
};

export default FoamRegistered;
